// extracted by mini-css-extract-plugin
module.exports = {"year-underlay":"YearUnderlay_year-underlay__Vf8B0","dark":"YearUnderlay_dark__1n8YK","year":"YearUnderlay_year__cVX-r"};